import { useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { SupportedCurrencies } from '@ninjablaze/sdk-ts'

import { TOKEN_PRICES_QUERY } from '@/api/query'

export const usePriceStore = () => {
  const { data } = useQuery(TOKEN_PRICES_QUERY)

  const getPrice = useCallback(
    (currency: SupportedCurrencies) => {
      const price = data?.tokenPrices?.nodes.find(
        (tokenPrice) => tokenPrice?.symbol.toLowerCase() === currency.toLowerCase()
      )?.value

      if (price !== undefined && Number.isFinite(Number(price))) {
        return Number(price)
      }

      return currency === SupportedCurrencies.USDC ? 1 : 0
    },
    [data]
  )

  return { getPrice }
}
